import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export const AuthLayout = ({ title, subtitle, children, footer, testId = "auth" }) => (
  <Layout testId={testId}>
    <section className="pt-24 md:pt-24 pb-20">
      <div className="max-w-md mx-auto px-6 lg:px-10">
        <div className="bg-white border border-[color:var(--gv-line)] rounded-[6px] p-8 md:p-10 shadow-[0_30px_80px_-40px_rgba(46,80,103,0.2)]">
          <h1 className="font-display text-[30px] md:text-[36px] leading-[1.1] text-[color:var(--gv-ink)] mb-2">
            {title}
          </h1>
          {subtitle && <p className="text-[14px] text-[color:var(--gv-ink)]/65 mb-7">{subtitle}</p>}
          {children}
        </div>
        {footer && (
          <div className="text-center mt-6 text-[13.5px] text-[color:var(--gv-ink)]/70">
            {footer}
          </div>
        )}
      </div>
    </section>
  </Layout>
);

export const AuthField = ({ label, error, children }) => (
  <label className="block mb-4">
    <span className="block mb-2 text-[12.5px] uppercase tracking-widest text-[color:var(--gv-ink)]/60">{label}</span>
    {children}
    {error && <span className="block mt-1.5 text-[12px] text-[#d03a5a]">{error}</span>}
  </label>
);

export default AuthLayout;
